import React from 'react'

import { ReceivementProduct } from '../../../ReceivementTypes'
import { DetailProductTable } from './DetailProductTable'
import { ProductTable } from './ProductTable'
import { WrongProductTable } from './WrongProductTable'

interface Props {
  product: ReceivementProduct
}

const ReceivementOverviewTable = ({ product }: Props) => (product.idReceivementAuthorization != null ? (
  <ProductTable product={product} />
) : <WrongProductTable product={product} />)

const ReceivementDetailOverviewTable = ({ product }: Props) => (product.idReceivementAuthorization != null ? (
  <DetailProductTable product={product} />
) : <WrongProductTable product={product} />)

export { ReceivementOverviewTable, ReceivementDetailOverviewTable }
